module.exports = __webpack_public_path__ + "static/media/like.45fc4958.svg";